<template>
	<div class="container">
		<div v-title>售后详情</div>
		<div class="tab-wrap" v-if="refundForm.status!=4 && refundForm.status!=5">
			<div class="tab-list">
				<div class="tab-item" :class="{'tab-checked':item.checked}" v-for="(item,index) in tabs" :key="index">
					{{item.label}}
				</div>
			</div>
		</div>
		<div class="tab-wrap" v-if="refundForm.status==5">
			<div class="tab-list">
				<div class="tab-item" :class="{'tab-checked':item.checked}" v-for="(item,index) in closeTabs" :key="index">
					{{item.label}}
				</div>
			</div>
		</div>
		<div class="tip-box" v-if="refundForm.status=='3'">
			<p class="tip-title">售后完成</p>
			<p class="tip-content">您的售后已完成</p>
		</div>
		<div class="tip-box" v-if="refundForm.status=='4'">
			<p class="tip-title">申请已取消</p>
			<p class="tip-content">若您的问题未解决，可在有效期内再次申请售后</p>
		</div>
		<div class="tip-box" v-if="refundForm.status=='5'">
			<p class="tip-title">已关闭</p>
			<p class="tip-content">亲爱的花友，您本次售后已关闭</p>
		</div>
		<div class="tip-box" v-if="refundForm.status=='21'">
			<p class="tip-title">请寄回商品</p>
			<p class="tip-content">请在
				<span class="residue-time">6天23小时</span>内填写快递单号
			</p>
		</div>
		<div class="tip-box" v-if="refundForm.status=='22' || refundForm.status=='23'">
			<p class="tip-title">待商家收货</p>
			<p class="tip-content">请在
				<span class="residue-time">6天23小时</span>后商家未处理将自动退款
			</p>
		</div>
		<div class="tip-box" v-if="refundForm.status=='24'">
			<p class="tip-title">退款中</p>
			<p class="tip-content">
				退款金额<span class="residue-time">14</span>个工作日内原路返回
			</p>
		</div>
		<div class="attention" @click="consultRecord">
			<span class="text">关注“花点时间”公众号,接收处理通知</span>
			<span class="attention-btn" v-if="refundForm.status!=3&&refundForm.status!=4&& refundForm.status!=5">联系客服</span>
		</div>
		<div class="get-express" v-if="(refundForm.status=='5' || refundForm.status=='24' || refundForm.status=='23' || refundForm.status=='3')&& refundForm.remark">
			{{refundForm.remark}}
		</div>
		<!--<div class="get-express" v-if="refundForm.status=='24' ">
			亲亲，已收到您上传的快递单号，因为快递运输需要一定时间
			我们收到货后会第一时间为您处理，请耐心等待～
		</div>-->
		<div class="express-wrap" v-if="refundForm.status=='22' || refundForm.status=='23' || refundForm.status=='24' || refundForm.status=='3'">
			<p class="express-box">
				<span class="addr-label">快递信息：</span>
				<span class="express-info">{{refundForm.refundLogisticsName}} {{refundForm.refundLogisticsNumber}}</span>
			</p>
			<span class="edit-btn" @click="fillIn" v-if="refundForm.status!='24' && refundForm.status!='3'">修改</span>
		</div>
		<div class="return-wrap" v-if="refundForm.status!='4' && refundForm.status!='5'">
			<div class="return-top">
				<span class="addr-label">退货地址：</span>
				<span class="copy-btn" v-clipboard:copy="refundForm.copyAddress" v-if="refundForm.status!='3'" v-clipboard:success="oncopy" v-clipboard:error="onerror">复制</span>
			</div>
			<p class="receive-person" v-html="refundForm.addressInfo"></p>
			<!--<p class="receive-addr receive-person">北京朝阳区大望路27后75栋星创园1层108室</p>-->
		</div>
		<div class="attention" v-if="refundForm.status!='4' && refundForm.status!='5'">
			<span class="text"><span v-if="refundForm.status!='3' && refundForm.status!='24'">预计</span>退款金额</span>
			<span class="sale-price">¥{{refundForm.refundAmount}}</span>
		</div>
		<div class="attention" @click="consultRecord">
			<span class="text">协商记录</span>
			<span class="go-record"></span>
		</div>
		<div class="attention" @click="showAttenAct">
			<span class="text">退款须知</span>
			<span class="go-notice"></span>
		</div>
		<div class="handle-box">
			<!--<div class="urge-dispose handle-btn">催处理</div>-->
			<div class="cancel-sale handle-btn" v-if="refundForm.status=='21'|| refundForm.status=='22'" @click="cancelAfter">撤销售后</div>
			<div class="cancel-sale handle-btn" v-if="refundForm.status=='4'|| refundForm.status=='5'" @click="applyAfter(1)">再次申请售后</div>
		</div>
		<div class="submit-box" v-if="refundForm.status=='21'">
			<div class="submit" @click="fillIn" >填写快递单号</div>
		</div>
		<div class="	tracking-wrap" @touchmove.prevent v-if="showTrack">
			<div class="tracking-box">
				<h2>填写物流信息</h2>
				<div class="form-group">
					<span class="form-label">快递公司</span>
					<input v-model="trackCompany" placeholder="请输入" />
				</div>
				<div class="form-group">
					<span class="form-label">快递单号</span>
					<input v-model="trackNumber" placeholder="请输入" />
				</div>
				<div class="tracking-handle">
					<div class="cancel-btn" @click="cancelFill">取消</div>
					<div class="submit-btn" @click="submitFill">确定</div>
				</div>
			</div>
		</div>
		<van-action-sheet v-model="showSheet" title="退货须知">
		  <div class="content sheet-content">
		  		<p>1、退货范围：仅支持非生鲜产品退货；</p>
		  		<p>2、退货要求：</p>
		  		<p class="child-text">a.	需保持商品未经使用、损坏、无污染、非人为损坏、未拆封，在不影响二次销售（特殊说明：香氛产品未拆塑封)；</p>
		  		<p class="child-text">b.	所有商品一并寄回（主商品、赠品）；</p>
		  		<p>3、退费说明：</p>
		  		<p class="child-text">a.	A质量问题退货运费由花点时间承担（用户自付运费寄后，运费与商品款一同退还）;</p>
		  		<p class="child-text">b.	七天无理由退货需自费运费；</p>
		  </div>
		</van-action-sheet>

	</div>
</template>

<script>
	import { Dialog, ActionSheet } from "vant";
	export default{
		components:{
			[ActionSheet.name]: ActionSheet
		},
		data() {
			return{
				tabs:[{
				label:"处理中",
				type: '1',
				checked:false
			},{
				label:"寄回物品",
				type: '21',
				checked:false
			},{
				label:"商家收货",
				type: '22',
				checked:false
			},{
				label:"退款中",
				type: '24',
				checked:false
			},{
				label:"售后完成",
				type: '3',
				checked:false
			}],
			closeTabs:[{
				label:"处理中",
				type: '1',
				checked:false
			},{
				label:"寄回物品",
				type: '21',
				checked:false
			},{
				label:"商家收货",
				type: '22',
				checked:false
			},{
				label:"已关闭",
				type: '5',
				checked:false
			}],
			isSubIng: false,
			showTrack: false,//输入快递弹窗
			trackCompany: "",
			trackNumber: "",//单号
			copyContent: '',
			showSheet: false,
			formId: '',//申请单ID
			status: '',//状态
			refundForm: {}
			}
			
		},
		created(){
			this.formId = this.$route.query.formId;
			this.status = this.$route.query.status;
			this.getRefundDetail()
		},
		methods:{
			getRefundDetail() {
				this.http({
					url: this.refundDetail + this.formId,
					method: 'get',
				}).then(res => {
					if(res.data.httpCode == 200) {
						let data= res.data.data
						this.refundForm= data
						if(data.addressInfo){
							this.refundForm.copyAddress = data.addressInfo.replace('<br/>','')
						}
							console.log(data.status)
						
						this.tabs.map(item=> {
							item.checked= false
							if(item.type ==data.status){
								console.log(item,'222')
								item.checked= true
							}
						})
						this.closeTabs.map(item=> {
							item.checked= false
							if(item.type ==data.status){
								console.log(item,'222')
								item.checked= true
							}
						})
					} else {
						this.popUp(res.data.msg)
					}
				})
			},
			checkTab(item) {
				this.tabs.map(item1=> {
					item1.checked= false
				})
				item.checked= true
			},
			//申请售后
			applyAfter() {
				this.$router.push({
					path: '/applyServer'
				})
			},
			//协商记录
			consultRecord() {
				this.$router.push({
					path: '/applyDetail',
					query: {
						formId: this.formId
					}
				})
			},
			fillIn() {
				this.showTrack= true
				if(this.refundForm.refundLogisticsName){
					this.trackCompany= this.refundForm.refundLogisticsName
				}
				if(this.refundForm.refundLogisticsNumber){
					this.trackNumber= this.refundForm.refundLogisticsNumber
				}
				console.log(111)
			},
			cancelFill() {
				this.showTrack= false
			},
			//提交
			submitFill() {
				
				if(this.trackCompany== ""){
					this.popUp('请填写快递公司名称！')
					return
				}
				if(this.trackNumber== ""){
					this.popUp('请填写快递单号！')
					return
				}
				let params= {
					formId: this.formId,
					detailId: this.refundForm.detailId,
					refundLogisticsName: this.trackCompany,
					refundLogisticsNumber: this.trackNumber
				}
				this.http({
					url: this.addExpress,
					method: 'post',
					data: params,
				}).then(res => {
					if(res.data.httpCode== "200"){
						this.popUp('快递信息提交成功！')
						this.refundDialog= false
						this.getRefundDetail()
					}
				})
				this.showTrack= false
			},
			//取消申请单
			cancelAfter() {
				this.http({
					url: this.cancelApply + this.formId,
					method: 'get',
				}).then(res => {
					if(res.data.httpCode == '200'){
						this.popUp("取消成功！")
						this.getRefundDetail()
					}else{
					
						this.popUp(res.data.msg)
					}
				}).catch(err=>{
						
						this.popUp('系统异常！请稍后重试')
				})
			},
			//复制
			oncopy (e) {
			 console.log(e,'eee')
			 this.popUp("复制成功！")
			},
			// 复制失败时的回调函数
			onerror (e) {
			 
			},
			showAttenAct() {
				this.showSheet= true
			},
			//跳转公众号文章
			goOfficial(){
//				window.location.href= "https://mp.weixin.qq.com/s/WJUgRdPufob1EEdU5rhN5g"
			},
				//tost
			popUp: function(content) {
				layer.open({
					content: content,
					skin: 'msg',
					time: 2 //2秒后自动关闭
				});
			},
		}
	}
</script>

<style scoped="scoped">
	*{
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
	.container{
		padding-bottom:2rem;
		color: #333333;
	}
	.tab-wrap{
		width: 100%;
	}
	.tab-list{
		padding: 0.373333rem 0.533333rem;
		display: flex;
		justify-content: space-between;
		
	}
	.tab-item{
		color: #333333;
		font-size: 0.373333rem;	
		font-weight: 500;	
	}
	.tab-checked{
		color: #AED000;
	}
	.tip-box{
		margin: 0.32rem 0.213333rem 0 0.213333rem;
		padding: 0.373333rem 0.346666rem;
		height: 2.133333rem;
		background: #fff;
		color: #333333;
		text-align: left;
	}
	.tip-box .tip-title{
		margin-bottom: 0.16rem;
		line-height: 0.666666rem;
		font-size: 0.48rem;
		font-weight: 700;
	}
	.tip-box .tip-content{
		line-height: 0.533333rem;
		font-size: 0.373333rem;
	}
	.residue-time{
		color: #C81313;
	}
	.attention{
		margin: 0.32rem 0.213333rem 0 0.213333rem;
		padding: 0 0.24rem 0 0.346666rem;
		height: 1.386666rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-weight: 700;
		background: #fff;
		font-size: 0.373333rem;
	}
	.attention .attention-btn{
		display: inline-block;
		width: 2.213333rem;
		height: 0.8rem;
		line-height: 0.8rem;
		font-size: 0.32rem;
		border: 0.026666rem solid #E2E2E2;
		border-radius: 0.4rem;
	}
	.attention .sale-price{
		color: #C81313;
		font-size: 0.426666rem;
	}
	.attention .go-record{
		width: 0.426666rem;
		height: 0.426666rem;
		background: url('https://misc.reflower.com.cn/images/mycenter/arrows.png') no-repeat center center;
		background-size: 100% 100%;
	}
	.attention .go-notice{
		width: 0.426666rem;
		height: 0.426666rem;
		background: url('../../../static/img/notice-icon.png') no-repeat center center;
		background-size: 100% 100%;
	}
	.get-express{
		margin: 0.32rem 0.213333rem 0 0.213333rem;
		padding: 0.293333rem 0.48rem 0.293333rem 0.346666rem;
		font-size: 0.32rem;
		line-height: 0.453333rem;
		text-align: left;
		background: #FFFFFF;
	}
	.express-wrap{
		margin: 0.32rem 0.213333rem 0 0.213333rem;
		padding: 0 0.24rem 0 0.346666rem;
		height: 1.386666rem;
		background: #FFFFFF;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.express-wrap .express-box{
		display: flex;
		align-items: center;
	}
	.express-wrap .addr-label{
		font-size: 0.373333rem;
		font-weight: 700;
	}
	.express-wrap .express-info{
		font-size: 0.32rem;
	}
	.express-wrap .edit-btn{
		display: block;
		width: 1.333333rem;
		height: 0.64rem;
		line-height: 0.64rem;
		font-size: 0.32rem;
		font-weight: 700;
		border: 0.026666rem solid #E2E2E2;
	}
	.return-wrap{
		margin: 0.32rem 0.213333rem 0 0.213333rem;
		padding: 0.24rem 0.24rem 0.32rem 0.346666rem;
		background: #fff;
	}
	.return-wrap .return-top{
		margin-bottom: 0.106666rem;
		display: flex;
		justify-content: space-between;
		height: 0.64rem;
		line-height: 0.64rem;
		font-size: 0.373333rem;
		
	}
	.return-wrap .return-top .addr-label{
		font-size: 0.373333rem;
		font-weight: 700;
	}
	.return-wrap .return-top .copy-btn{
		display: inline-block;
		width: 1.333333rem;
		/*height: 0.64rem;*/
		border: 0.026666rem solid #E2E2E2;
	}
	.receive-person{
		margin-bottom: 0.053333rem;
		line-height: 0.533333rem;
		font-size: 0.373333rem;
		font-weight:400;
		text-align: center;
		text-align: left;
	}
	.handle-box{
		margin-top: 0.32rem;
		display: flex;
		justify-content: flex-end;
	}
	.handle-box .handle-btn{
		width: 2.746666rem;
		height: 1.013333rem;
		line-height: 1.013333rem;
		border-radius: 0.48rem;
		font-size: 0.373333rem;
		font-weight: 700;
		border: 0.026666rem solid #E2E2E2;
	}
	.handle-box .urge-dispose{
		color: #C81313;
		margin-right: 0.373333rem;
	}
	.handle-box .cancel-sale{
		margin-right: 0.453333rem;
	}
	.submit-box{
		padding: 0 0.213333rem;
		width: 100%;
		height: 2rem;
		position: fixed;
		bottom: 0;
		left: 0;
		background: #f4f4f4;
		opacity: 1;
	}
	.submit {
		height: 1.306666rem;
		line-height: 1.306666rem;
		font-size: 0.48rem;
		color: #FFFFFF;
		background-color: #262628;
	}
	/*填写弹窗*/
	.tracking-wrap{
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1000;
	}
	.tracking-wrap::before{
		content: '';
		z-index: 0;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: #000;
		opacity: 0.26;
	}
	.tracking-box{
		position: absolute;
		left: 0.906666rem;
		top: 3.76rem;
		padding: 0.32rem 0 0 0.4rem;
		width: 8.32rem;
		height: 5.946666rem;
		background: #FFFFFF;
		border-radius: 0.16rem;
		text-align: left;
	}
	.tracking-box h2{
		margin-bottom: 0.48rem;
		line-height: 0.586666rem;
		font-size: 0.426666rem;
		font-weight: bold;
	}
	.tracking-box .form-group{
		margin-bottom: 0.426666rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		height: 0.96rem;
	}
	/*.form-group:first-of-type{
		margin-bottom: 0.426666rem;
	}*/
	.tracking-box .form-group .form-label{
		margin-right: 0.32rem;
		font-size: 0.373333rem;
		font-weight: bold;
	}
	.tracking-box .form-group input{
		padding-left: 0.24rem;
		display: inline-block;
		width: 5.28rem;
		height: 0.96rem;
		line-height: 0.96rem;
		background: #F7F7F7;
		font-size: 0.32rem;
		outline: none;
		border: none;
	}
	.tracking-handle{
		padding-right:0.453333rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 0.426666rem;
		font-weight: bold;
		text-align: center;
	}
	.tracking-handle .cancel-btn{
		width: 3.44rem;
		height: 1.226666rem;
		line-height: 1.226666rem;
		background: #F7F7F7;
		color: #262628;
		border-radius: 0.16rem;
	}
	.tracking-handle .submit-btn{
		width: 3.44rem;
		height: 1.226666rem;
		line-height: 1.226666rem;
		background: #262628;
		color: #FFFFFF;
		border-radius: 0.16rem;
	}
	.sheet-content{
		padding: 0 0.4rem;
		font-size: 0.373333rem;
		text-align: left;
	}
	.sheet-content p{
		margin-bottom: 0.533333rem;
		line-height: 0.533333rem;
		color: #333333;
		font-weight: bold;
	}
	.sheet-content .child-text{
		font-size: 0.346666rem;
		font-weight: normal;
		margin-bottom: 0.266666rem;
	}
</style>


// WEBPACK FOOTER //
// src/path/salesReturn/saleDetail.vue